class MainSearch extends SearchForm {
  constructor() {
    super();
    this.allSearchInputs = document.querySelectorAll('input[type="search"][name="q"]');
    this.setupEventListeners();
  }

  setupEventListeners() {
    let allSearchForms = [];
    this.allSearchInputs.forEach((input) => allSearchForms.push(input.form));
    this.input.addEventListener('focus', this.onInputFocus.bind(this));
    if (allSearchForms.length < 2) return;
    allSearchForms.filter((form, index, forms) => form && form !== this.input.form && forms.indexOf(form) === index).forEach((form) => form.addEventListener('reset', this.onFormReset.bind(this)));
    this.allSearchInputs.forEach((input) => input.addEventListener('input', this.onInput.bind(this)));
  }

  onFormReset(event) {
    if (event.target === this.input.form) super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.keepInSync('', null);
    }
  }

  onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
  }

  onInputFocus() {
    const isSmallScreen = window.innerWidth < 750;
    if (isSmallScreen) {
      this.scrollIntoView({ behavior: 'smooth' });
    }
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input !== target) {
        input.value = value;
        const owner = input.closest('predictive-search, search-form, main-search');
        if (owner && typeof owner.toggleResetButton === 'function') owner.toggleResetButton();
        if (!value && owner && typeof owner.closeResults === 'function') owner.closeResults(true);
      }
    });
  }
}

customElements.define('main-search', MainSearch);
